import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import { OrdersApisActionTypes } from './constants';
import { ordersApiResponseSuccess, ordersApiResponseError } from './actions';
import { APICore } from '../../helpers/api/apiCore';

const api = new APICore();

function* ordersApis(): SagaIterator {
    try {
        const response = yield call(() => api.get(`/orders`, {}));
        const data = response.data || response;
        yield put(ordersApiResponseSuccess(OrdersApisActionTypes.GET_ORDERS_APIS_DATA, data));
    } catch (error: any) {
        console.log(error, 'error---');
        yield put(
            ordersApiResponseError(OrdersApisActionTypes.GET_ORDERS_APIS_DATA, error.message || 'Something Went Wrong')
        );
    }
}

export function* watchOrdersApis() {
    yield takeEvery(OrdersApisActionTypes.GET_ORDERS_APIS_DATA, ordersApis);
}

function* ordersApisSaga() {
    yield all([fork(watchOrdersApis)]);
}

export default ordersApisSaga;
